import { ref } from 'vue';

const backLink = ref<string | null>(null);

export function usePageBack() {
    return { backLink };
}
